import { Props } from "react-select";
import { SelectField } from "../fields/SelectField";
import { useController, useFormContext } from "react-hook-form";
import React from "react";

type OwnProps = {
  label?: string;
  helperText?: string;
  name: string;
  onChange?: (value: string) => void;
  options: { label: React.ReactNode; value: string | number }[];
} & Props;

export const SelectInput = ({ name, onChange, options, ...rest }: OwnProps) => {
  const { control, formState, getFieldState } = useFormContext();

  const {
    field: { ref, value, onChange: controllerOnChange, ...controllerRest },
  } = useController({
    name: name as string,
    control,
  });

  return (
    <SelectField
      innerRef={ref}
      errorMessage={getFieldState(name as string, formState).error?.message}
      onChange={(value) => {
        const newValue = value as { value: string; label: string };
        controllerOnChange(newValue.value);
        if (onChange) {
          onChange(newValue.value);
        }
      }}
      options={options}
      value={options?.find((option) => option.value === value)}
      {...rest}
      {...controllerRest}
    />
  );
};
